import { render } from "./ModalSolicitacao.vue?vue&type=template&id=066bab02&scoped=true"
import script from "./ModalSolicitacao.vue?vue&type=script&lang=js"
export * from "./ModalSolicitacao.vue?vue&type=script&lang=js"

import "./ModalSolicitacao.vue?vue&type=style&index=0&id=066bab02&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066bab02"]])

export default __exports__